<nz-table class="full-width" #workspaceTable [nzData]="workspaceList()" [nzPaginationType]="'small'" [nzPageSize]="8">
  <thead>
    <tr>
      <th>Id</th>
      <th>Workspace Name</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (workspace of workspaceTable.data; track $index) {
      <tr>
        <td>
          <app-copy-button [text]="workspace.id"></app-copy-button>
        </td>
        <td>
          {{ workspace.title }}
        </td>
        <td>
          <div class="horizontal">
            @if (currentWorkspace().id !== workspace.id) {
              <a [href]="'/workspace/' + workspace.id" nz-button nzType="default" nzSize="small"
                ><span nz-icon style="font-size: 16px" class="material-symbols-rounded">north_east</span> Open</a
              >
            } @else {
              <nz-tag [nzColor]="'volcano'">Current Workspace</nz-tag>
            }
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
